import { render, staticRenderFns } from "./DevFAB.vue?vue&type=template&id=69a05881"
import script from "./DevFAB.vue?vue&type=script&lang=js"
export * from "./DevFAB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports